import PropTypes from 'prop-types'
import { Typography, Grid, Box } from '@mui/material'

import {
  SHIPPINGS_TABLE_HEADER_ORDER,
  SHIPPINGS_TABLE_HEAD_CELLS_NO_SORTABLE,
} from '../../common/constants'
import useTranslations from '../../i18n/useTranslations'
import Loader from '../../ui/views/Loader'
import ShippingsOverview from '../ShippingsOverview'

import useStyles from './styles'

const SearchResults = ({
  isFetching,
  searchResults,
  states,
  isLoadingShippingsStates,
  onClickResolveIncident,
}) => {
  const classes = useStyles()
  const t = useTranslations()
  return (
    <>
      {isFetching || isLoadingShippingsStates ? (
        <Box className={classes.resultsLoaderWrapper}>
          <Loader />
        </Box>
      ) : !Boolean(searchResults) || searchResults?.length === 0 ? null : (
        <Grid item xs={12}>
          <Typography
            className={classes.mainDescription}
            mb={1}
            sx={{ color: 'neutral.main' }}
          >
            {t('home:shipment-search-results')}
          </Typography>
          <ShippingsOverview
            headCells={SHIPPINGS_TABLE_HEAD_CELLS_NO_SORTABLE}
            headCellsOrder={SHIPPINGS_TABLE_HEADER_ORDER}
            rows={searchResults}
            states={states}
            showIcon
            showMenu
            showPagination={false}
            onClickResolveIncident={onClickResolveIncident}
          />
        </Grid>
      )}
    </>
  )
}

SearchResults.propTypes = {
  isFetching: PropTypes.bool,
  searchResults: PropTypes.array,
  states: PropTypes.array,
  isLoadingShippingsStates: PropTypes.bool,
  onClickResolveIncident: PropTypes.func,
}

export default SearchResults
